var map = {
	"./img/222.jpg": 316,
	"./img/Kolumne.jpeg": 317,
	"./img/aaa.png": 160,
	"./img/bridge.jpg": 318,
	"./img/bridge5.jpg": 319,
	"./img/cg.jpg": 97,
	"./img/cg0.jpg": 320,
	"./img/cg1.jpg": 321,
	"./img/cg2.jpg": 322,
	"./img/clouds.png": 161,
	"./img/daniel-olahs.jpg": 323,
	"./img/faces/clem-onojeghuo-2.jpg": 324,
	"./img/faces/erik-lucatero-2.jpg": 325,
	"./img/faces/joe-gardner-2.jpg": 326,
	"./img/favicon.ico": 327,
	"./img/favicon.png": 328,
	"./img/fog-low.png": 98,
	"./img/grb.png": 329,
	"./img/manastir.jpg": 330,
	"./img/muzej.jpg": 162,
	"./img/nucleo-logo.svg": 331,
	"./img/plavidvoraccetinje.jpg": 332
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 159;